module.exports = __webpack_public_path__ + "images/507faeb9446696d4e6461767f3e78c7515ea0fbde16c5cb600ad75ffd334521b.svg";